import { IProfile } from 'common/modules/ReactShared';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { authActions } from 'students/stores/auth';
import { userSelectors } from 'students/stores/user';
import darkInkLogo from 'students/views/shared/assets/lingu-logo.svg';
import lightInkLogo from 'students/views/shared/assets/lingu-light-logo.svg';
import { useBreakpointNumber } from 'students/views/shared/hooks';
import { useColorTheme, useFixedSurface } from 'students/views/shared/providers/Theme';

import { useTypedDispatch, useTypedSelector } from 'students/stores/_utils';
import { navigationDesktopBreakPoint } from '../theme/breakpoints';
import useShowDesktopNavigation from './useShowDesktopNavigation';

interface IUseNavBar {
  logoSrc: string;
  userProfile: IProfile | null;
  isNavigationVisible: boolean;
  handleLogOut: () => void;
}

export default function useNavBar(): IUseNavBar {
  const history = useHistory();
  const isBigScreen = useShowDesktopNavigation();
  const dispatch = useTypedDispatch();
  const userProfile = useTypedSelector(userSelectors.selectProfile);

  const { theme } = useColorTheme();
  const isFixedSurface = useFixedSurface();
  const isSidebarLayout = useBreakpointNumber(navigationDesktopBreakPoint);
  // Below the sidebar layout a fixed surface pins the bar dark (see NavBar), so its ink stays light.
  const hasDarkInk = theme === 'light' && !(isFixedSurface && !isSidebarLayout);
  const logoSrc = hasDarkInk ? darkInkLogo : lightInkLogo;

  const handleLogOut = useCallback(async () => {
    await dispatch(authActions.logOut());
    history.push('/');
  }, [dispatch, history]);

  return { logoSrc, userProfile, isNavigationVisible: isBigScreen, handleLogOut };
}
